export { default } from './DeleteConfirmationModal';